import { render } from "./DropProfileSettingsPage.vue?vue&type=template&id=163e3c1a"
import script from "./DropProfileSettingsPage.vue?vue&type=script&lang=js"
export * from "./DropProfileSettingsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__